/*
 * @Description: 混合模式之全局方法应用
 * @Author: gao shuai
 * @Date: 2020-02-25 15:46:39
 * @LastEditTime: 2020-07-03 18:07:30
 * @LastEditors: gao shuai
 */
export default {
  methods: {
    getNewTime() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var h = date.getHours();
      var m = date.getMinutes();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      if (h < 10) {
        h = '0' + h;
      }
      if (m < 10) {
        m = '0' + m;
      }
      return year + '-' + month + '-' + day + ' ' + h + ':' + m;
    }
  },
  created() {
  },
  mounted() {}
};
